import { render } from "./GroupToolsStudentList.vue?vue&type=template&id=1c2c7050"
import script from "./GroupToolsStudentList.vue?vue&type=script&lang=js"
export * from "./GroupToolsStudentList.vue?vue&type=script&lang=js"

import "./GroupToolsStudentList.vue?vue&type=style&index=0&id=1c2c7050&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__